import Client from 'config/axios';

export const TwitterToken = async (token: string) => {
  return await Client.get(`get-authentication-url/twitter`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
